import { useTranslation } from "react-i18next";
import SectionPage from "../SectionPage/SectionPage";
import styles from "./AboutSection.module.css";

import { ChevronLeft } from "lucide-react"; 
import { useNavigate } from "react-router-dom";


import aboutImage from "../../assets/about/aboutus-ucs.png";

const AboutSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <SectionPage
      id="about"
      contentTitle={t("about.contentTitle")}
      className={styles.centered}
    >
      {/* Chevron връщане */}
      <button 
        className={styles.backButton} 
        onClick={() => navigate("/")}
        aria-label="Go back home"
      >
        <ChevronLeft size={24} /> {t("about.backHome")}
      </button>

      <img src={aboutImage} alt="About" className={styles.aboutImage} />

      <p className={styles.note}>{t("about.note")}</p>
    </SectionPage>
  );
};

export default AboutSection;
